import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { HighlightPropertyModel } from 'src/app/models/highlights-property.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-desktop',
  templateUrl: './home-desktop.component.html',
  styleUrls: ['./home-desktop.component.css']
})
export class HomeDesktopComponent implements OnInit, AfterViewInit {
  @Input() highlightsProperties: HighlightPropertyModel[] = [];
  @Input() localAccommodations: HighlightPropertyModel[] = [];
  @Input() searchData!: any;
  @Input() latestSearches!: any;
  @Input() networkStatus: any;
  homeTexts: boolean = environment.homeTexts;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if (this.highlightsProperties?.length > 0) {
        clearInterval(interval);
      }
    })
  }

}
